import { Google, Pixall } from '../analytics/index.js';
export const USER_ACCOUNT_EVENT_SOURCE = 'userAccount';
export const MYKBB_EVENT_FEATURE = 'global-nav-header';
export const getPixallEventData = _ref => {
  let {
    eventSource,
    pageType,
    feature,
    label,
    pageId,
    cdl
  } = _ref;
  return {
    eventSource: eventSource || USER_ACCOUNT_EVENT_SOURCE,
    pageType: pageType || 'my-kbb',
    feature: feature || MYKBB_EVENT_FEATURE,
    label,
    pageId,
    hasListingType: false,
    cdl
  };
};
export const myKbbMenuClick = function (eventData, dataLayer) {
  if (eventData === void 0) {
    eventData = {};
  }
  if (dataLayer === void 0) {
    dataLayer = {};
  }
  const {
    pixallData,
    eventLabel
  } = eventData;
  const {
    page
  } = dataLayer;
  Google.sendClickEvent({
    eventElement: MYKBB_EVENT_FEATURE,
    eventResult: eventLabel
  }, {});
  Pixall.sendClickEvent({
    ...getPixallEventData({
      ...pixallData,
      pageId: page?.pg
    })
  }, dataLayer, {});
  return {};
};
export const myKbbMenuImpression = function (eventData, dataLayer) {
  if (eventData === void 0) {
    eventData = {};
  }
  if (dataLayer === void 0) {
    dataLayer = {};
  }
  const {
    eventLabel,
    pixallData
  } = eventData;
  const {
    page
  } = dataLayer;
  Google.sendImpressions({}, {
    eventElement: MYKBB_EVENT_FEATURE,
    eventResult: eventLabel
  }, {});
  Pixall.sendImpression({
    dataLayer
  }, {
    ...getPixallEventData({
      ...pixallData,
      pageId: page?.pg
    })
  }, {});
  return {};
};